module.exports = __webpack_public_path__ + "img/toto_1.474994e0.jpg";